<template>
    <div class="w-100 d-flex flex-column align-center">





        <div class="toggle__button-container">
            <button class="rounded-pill text-transform-none h-100 toggle__button"
                :class="activeOption === 'last7' ? 'toggle__button--selected' : 'toggle__button--unselected'"
                @click="changeTab('last7')">Weekly
            </button>

            <button class="rounded-pill text-transform-none h-100 toggle__button"
                :class="activeOption === 'last30' ? 'toggle__button--selected' : 'toggle__button--unselected'"
                @click="changeTab('last30')">Monthly
            </button>

            <button class="rounded-pill text-transform-none h-100 toggle__button"
                :class="activeOption === 'allTime' ? 'toggle__button--selected' : 'toggle__button--unselected'"
                @click="changeTab('allTime')">All Time
            </button>
        </div>





        <div class="w-100 mt-16">
            <slot :name="activeOption"></slot>
        </div>





    </div>
</template>



<script setup>

import { ref } from 'vue';

const emit = defineEmits(['changeTab']);
const activeOption = ref('last7');

const changeTab = (tab) => {
    activeOption.value = tab;
    emit('changeTab', tab);
};

</script>



<style scoped lang="scss">
.toggle__button-container {
    grid-template-columns: 1fr 1fr 1fr;

    @media only screen and (max-width: vars.get-map-value(vars.$breakpoints, 'mobile')) {
        width: 300px;
    }
}
</style>
